import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const IconGlobeGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);

  return (
    <g {...(props.group ?? {})}>
      <path
        d="M0.75 7.54688C0.75 8.43945 0.925806 9.32329 1.26738 10.1479C1.60896 10.9726 2.10961 11.7218 2.74076 12.353C3.37191 12.9841 4.12119 13.4848 4.94582 13.8264C5.77046 14.1679 6.6543 14.3437 7.54688 14.3438C8.43945 14.3437 9.32329 14.1679 10.1479 13.8264C10.9726 13.4848 11.7218 12.9841 12.353 12.353C12.9841 11.7218 13.4848 10.9726 13.8264 10.1479C14.1679 9.32329 14.3438 8.43945 14.3438 7.54687C14.3438 6.6543 14.1679 5.77046 13.8264 4.94582C13.4848 4.12119 12.9841 3.37191 12.353 2.74076C11.7218 2.10961 10.9726 1.60896 10.1479 1.26738C9.32329 0.925806 8.43945 0.75 7.54688 0.75C6.6543 0.75 5.77046 0.925806 4.94582 1.26738C4.12119 1.60896 3.37191 2.10961 2.74076 2.74076C2.10961 3.37191 1.60896 4.12119 1.26738 4.94582C0.925806 5.77046 0.75 6.6543 0.75 7.54688Z"
        stroke={fillColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.26669 14.2229C5.31815 12.8938 4.67773 10.3986 4.67773 7.5771C4.67773 4.75565 5.31815 2.20002 6.26669 0.901062"
        stroke={fillColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.82813 14.2229C9.77667 12.8938 10.4171 10.3986 10.4171 7.5771C10.4171 4.75565 9.77667 2.20002 8.82812 0.901062"
        stroke={fillColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.75 7.54688L14.3438 7.54687"
        stroke={fillColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.53516 10.7188L13.5581 10.7187"
        stroke={fillColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.53516 4.375L13.5581 4.375"
        stroke={fillColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  );
};

export const IconGlobeSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...(props.svg ?? {})}
    >
      <IconGlobeGroup {...props} />
    </svg>
  );
};
